"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Gravatar = function Gravatar(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.0",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(0.000000,24.000000) scale(0.100000,-0.100000)",
    fill: fill,
    stroke: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M96 225 c-12 -31 -6 -102 9 -115 20 -17 45 4 45 37 0 22 2 24 15 13 37 -31 5 -100 -47 -100 -52 0 -67 41 -43 117 11 33 -20 42 -48 14 -17 -16 -22 -34 -22 -71 0 -43 5 -54 33 -82 47 -48 117 -48 164 0 28 28 33 39 33 82 0 42 -5 54 -30 80 -37 37 -99 51 -109 25z m74 -10 c32 -17 60 -61 60 -95 0 -53 -57 -110 -110 -110 -34 0 -78 28 -95 60 -19 37 -19 63 0 100 19 36 51 42 40 8 -18 -57 -17 -86 4 -107 12 -12 34 -21 51 -21 63 0 93 77 48 123 l-23 22 -5 -40 c-7 -57 -34 -55 -38 4 -5 74 10 86 68 56z"
  })));
};
Gravatar.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Gravatar.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Gravatar;